import { Box, TextField } from "@mui/material";
import { DateField, Edit } from "@refinedev/mui";

import { useForm } from "@refinedev/react-hook-form";
import MutedStatus from "@warriortrading/warriortrading.hermes.common.feathers/enums/mutedStatus";
import UserGroup from "@warriortrading/warriortrading.hermes.common.feathers/enums/userGroup";
import WatchedStatus from "@warriortrading/warriortrading.hermes.common.feathers/enums/watchedStatus";
import { Controller } from "react-hook-form";

import MenuItem from "@mui/material/MenuItem";
import { DataGrid, GridColumns } from "@mui/x-data-grid";
import { BaseRecord } from "@refinedev/core";
import UserRole from "@warriortrading/warriortrading.hermes.common.feathers/enums/userRole";
import { RoomMembersDelBtn } from "components/buttons/roomMembersDelBtn";
import { RoomMembersEditBtn } from "components/buttons/roomMembersEditBtn";
import { ToRoomButton } from "components/buttons/toRoom";
import { UserBadgeRelationDelBtn } from "components/buttons/userBadgeRelationDelBtn";
import { UserBadgeRelationEditBtn } from "components/buttons/userBadgeRelationEditBtn";
import { AuthorityList } from "components/crud/authorityList";
import { UserBadgeRelationsList } from "components/crud/userBadgeRelationsList";
import { config } from "config";
import getData from "helper";
import React, { useEffect, useState } from "react";
import { dataProvider } from "rest-data-provider";
import { PasswordList } from "../../components/crud/passwordList";
import { RoomMembersList } from "../../components/crud/roomMembersList";

export const UserEdit = () => {
  const apiUrl = config().server.api;

  const {
    saveButtonProps,
    refineCore: { queryResult },
    register,
    control,
    setValue,
    formState: { errors },
  } = useForm();

  const userData = queryResult?.data?.data;

  const watchedStatusArr = Object.values(WatchedStatus)[0].map((item: any) => {
    return { value: item.value, label: item.name };
  });
  const mutedStatusArr = Object.values(MutedStatus)[0].map((item: any) => {
    return { value: item.value, label: item.name };
  });
  const userGroupArr = Object.values(UserGroup)[0].map((item: any) => {
    return { value: item.value, label: item.name };
  });
  const [mutedStatus, setMutedStatus] = useState(0);
  const [watchedStatus, setWatchedStatus] = useState(0);
  const [userGroup, setUserGroup] = useState(0);
  const [flag, setFlag] = useState(false);
  const [amISuper, setAmISuper] = useState(false);
  const [userBadgeRelations, setUserBadgeRelations] = useState(
    [] as BaseRecord[]
  );

  const [roomMembers, setRoomMembers] = useState([] as BaseRecord[]);
  useEffect(() => {
    const authorization = sessionStorage.getItem("authorization");
    getData(authorization as string).then((res) => {
      if (res) setAmISuper(res.user.group === 0);
    });
  }, []);

  useEffect(() => {
    setMutedStatus(userData?.mutedStatus);
    setWatchedStatus(userData?.watchedStatus);
    setUserGroup(userData?.group);
  }, [userData?.group, userData?.mutedStatus, userData?.watchedStatus]);
  useEffect(() => {
    userData?.id &&
      dataProvider(apiUrl)
        .getList({
          resource: "user-badge-relations",
          filters: [{ field: "userId", operator: "eq", value: userData?.id }],
        })
        .then((res) => {
          setUserBadgeRelations(res.data);
          setFlag(false);
        });
  }, [apiUrl, userData?.id, flag]);

  useEffect(() => {
    userData?.id &&
      dataProvider(apiUrl)
        .getList({
          resource: "room-member",
          filters: [{ field: "userId", operator: "eq", value: userData?.id }],
        })
        .then((res) => {
          setRoomMembers(res.data);
        });
  }, [apiUrl, userData?.id, flag]);

  const roomMembersColumns = React.useMemo<GridColumns<any>>(
    () => [
      {
        field: "room.title",
        headerName: "Room Title",
        type: "number",
        minWidth: 200,
      },
      {
        field: "role",
        flex: 1,
        headerName: "Role",
        minWidth: 40,
        renderCell: function render({ value }) {
          return UserRole.fromValue(value)?.name;
        },
      },
      {
        field: "actions",
        headerName: "Actions",
        sortable: false,
        renderCell: function render({ row }) {
          return (
            <>
              <RoomMembersEditBtn
                hideText
                recordItemId={row.id}
                userRole={row.role}
                dataUpdate={handleDataUpdate}
              />
              {/* TODO ToRoomButton */}
              <ToRoomButton hideText recordItemId={row.roomId} />
              <RoomMembersDelBtn
                hideText
                recordItemId={row.id}
                dataUpdate={handleDataUpdate}
              />
            </>
          );
        },
        align: "center",
        headerAlign: "center",
        minWidth: 140,
      },
    ],
    []
  );
  const userBadgeRelationsColumns = React.useMemo<GridColumns<any>>(
    () => [
      {
        field: "badge.badgeUrl",
        flex: 1,
        headerName: "Badge Url",
        minWidth: 80,
        renderCell: function render({ value }) {
          return (
            <img
              src={value !== "" ? value : "/default_badge.svg"}
              alt="BadgeUrl"
              style={{ height: "50px", maxWidth: "100px" }}
            />
          );
        },
      },
      {
        field: "badge.code",
        headerName: "Code",
        type: "number",
        minWidth: 30,
      },
      {
        field: "badge.name",
        flex: 1,
        headerName: "Name",
        minWidth: 100,
      },
      {
        field: "issueDate",
        flex: 1,
        headerName: "IssueDate",
        minWidth: 100,
        renderCell: function render({ value }) {
          return <DateField value={value} />;
        },
      },

      {
        field: "expirationDate",
        headerName: "ExpirationDate",
        minWidth: 100,
        renderCell: function render({ value }) {
          return <DateField value={value} />;
        },
      },
      {
        field: "actions",
        headerName: "Actions",
        sortable: false,
        renderCell: function render({ row }) {
          return (
            <>
              <UserBadgeRelationEditBtn
                hideText
                recordItemId={row.id}
                dataUpdate={handleDataUpdate}
              />
              <UserBadgeRelationDelBtn
                hideText
                recordItemId={row.id}
                dataUpdate={handleDataUpdate}
              />
            </>
          );
        },
        align: "center",
        headerAlign: "center",
        minWidth: 80,
      },
    ],
    []
  );
  const handleDataUpdate = (e: any) => {
    setFlag(e);
  };
  return (
    <div>
      <Edit saveButtonProps={saveButtonProps}>
        <Box
          component="form"
          sx={{ "& .MuiTextField-root": { m: 1, width: "25ch" } }}
          autoComplete="off"
        >
          <TextField
            {...register("nickname", {
              required: "This field is required",
            })}
            error={!!(errors as any)?.nickname}
            helperText={(errors as any)?.nickname?.message}
            margin="normal"
            InputLabelProps={{ shrink: true }}
            type="string"
            label="Nickname"
            name="nickname"
          />
          <TextField
            {...register("email", {
              required: "This field is required",
            })}
            error={!!(errors as any)?.email}
            helperText={(errors as any)?.email?.message}
            margin="normal"
            InputLabelProps={{ shrink: true }}
            type="email"
            label="Email"
            name="email"
            disabled
          />
          <TextField
            required
            select
            value={mutedStatus ?? ""}
            defaultValue={0}
            label="Muted Status"
            margin="normal"
            onChange={(e) => {
              setMutedStatus(e.target.value as unknown as number);
              setValue("mutedStatus", e.target.value);
            }}
          >
            {mutedStatusArr.map((option: any) => (
              <MenuItem key={option.value} value={option.value}>
                {option.label}
              </MenuItem>
            ))}
          </TextField>
          <TextField
            required
            select
            defaultValue={0}
            value={watchedStatus ?? ""}
            margin="normal"
            label="Watched Status"
            onChange={(e) => {
              setWatchedStatus(e.target.value as unknown as number);
              setValue("watchedStatus", e.target.value);
            }}
          >
            {watchedStatusArr.map((option: any) => (
              <MenuItem key={option.value} value={option.value}>
                {option.label}
              </MenuItem>
            ))}
          </TextField>
          <TextField
            {...register("watchedReason", {})}
            error={!!(errors as any)?.watchedReason}
            helperText={(errors as any)?.watchedReason?.message}
            margin="normal"
            InputLabelProps={{ shrink: true }}
            type="string"
            label="Watched Reason"
            name="watchedReason"
            disabled
          />
          <TextField
            required
            select
            value={userGroup ?? ""}
            defaultValue={0}
            margin="normal"
            label="Group"
            onChange={(e) => {
              setUserGroup(e.target.value as unknown as number);
              setValue("group", e.target.value);
            }}
            disabled={!amISuper}
          >
            {userGroupArr.map((option: any) => (
              <MenuItem key={option.value} value={option.value}>
                {option.label}
              </MenuItem>
            ))}
          </TextField>
          <Controller
            control={control}
            name="showFullName"
            defaultValue={false}
            render={({ field }) => {
              return (
                <TextField
                  select
                  value={field.value}
                  label="Show Full Name"
                  onChange={(e) => {
                    field.onChange(e.target.value);
                  }}
                >
                  {[
                    { value: true, label: "Yes" },
                    { value: false, label: "No" },
                  ].map((option: any) => (
                    <MenuItem key={option.value} value={option.value}>
                      {option.label}
                    </MenuItem>
                  ))}
                </TextField>
              );
            }}
          />
          <Controller
            control={control}
            name="messageAlarm"
            defaultValue={false}
            render={({ field }) => {
              return (
                <TextField
                  select
                  value={field.value}
                  label="Message Alarm"
                  onChange={(e) => {
                    field.onChange(e.target.value);
                  }}
                >
                  {[
                    { value: true, label: "Yes" },
                    { value: false, label: "No" },
                  ].map((option: any) => (
                    <MenuItem key={option.value} value={option.value}>
                      {option.label}
                    </MenuItem>
                  ))}
                </TextField>
              );
            }}
          />
          <TextField
            {...register("uuid", {
              required: "This field is required",
              valueAsNumber: true,
            })}
            error={!!(errors as any)?.uuid}
            helperText={(errors as any)?.uuid?.message}
            margin="normal"
            InputLabelProps={{ shrink: true }}
            type="number"
            label="UUID"
            name="uuid"
            disabled
          />
          <TextField
            {...register("products", {})}
            error={!!(errors as any)?.products}
            helperText={(errors as any)?.products?.message}
            margin="normal"
            InputLabelProps={{ shrink: true }}
            label="Products"
            name="products"
            disabled
          />
          <TextField
            {...register("prodCategories", {})}
            error={!!(errors as any)?.prodCategories}
            helperText={(errors as any)?.prodCategories?.message}
            margin="normal"
            InputLabelProps={{ shrink: true }}
            label="Product Categories"
            name="prodCategories"
            disabled
          />
          <TextField
            {...register("quotestreamPackages", {})}
            error={!!(errors as any)?.quotestreamPackages}
            helperText={(errors as any)?.quotestreamPackages?.message}
            margin="normal"
            InputLabelProps={{ shrink: true }}
            label="Quotestream Packages"
            name="quotestreamPackages"
            disabled
          />
          <TextField
            {...register("createdAt", {
              required: "This field is required",
            })}
            error={!!(errors as any)?.createdAt}
            helperText={(errors as any)?.createdAt?.message}
            margin="normal"
            InputLabelProps={{ shrink: true }}
            label="Created At"
            name="createdAt"
            disabled
          />
          <TextField
            {...register("updatedAt", {
              required: "This field is required",
            })}
            error={!!(errors as any)?.updatedAt}
            helperText={(errors as any)?.updatedAt?.message}
            margin="normal"
            InputLabelProps={{ shrink: true }}
            label="Updated At"
            name="updatedAt"
            disabled
          />
          <TextField
            {...register("signedUpDate", {
              required: "This field is required",
            })}
            error={!!(errors as any)?.signedUpDate}
            helperText={
              (errors as any) &&
              "Recommend signed up date: 1973-11-29T21:33:09.012Z"
            }
            margin="normal"
            InputLabelProps={{ shrink: true }}
            type="string"
            label="Signed Up Date"
            name="signedUpDate"
          />
        </Box>
      </Edit>
      <br />
      {amISuper && userGroup === 1 ? (
        <>
          <AuthorityList id={userData?.id} />
          <br />
        </>
      ) : null}

      <PasswordList uuid={userData?.uuid}></PasswordList>
      <br />
      <RoomMembersList userId={userData?.id} dataUpdate={handleDataUpdate}>
        <DataGrid
          hideFooter
          rows={roomMembers}
          columns={roomMembersColumns}
          autoHeight
        />
      </RoomMembersList>
      <br />
      <UserBadgeRelationsList
        userId={userData?.id}
        dataUpdate={handleDataUpdate}
      >
        <DataGrid
          hideFooter
          rows={userBadgeRelations}
          columns={userBadgeRelationsColumns}
          autoHeight
        />
      </UserBadgeRelationsList>
    </div>
  );
};
